import React from "react";
import Select from "react-select";

const styles = {
  container: (base) => ({ ...base, width: "100%", maxWidth: 110 }),
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    borderRadius: 10,
    borderColor: state.isFocused ? "#3b82f6" : "#dbe3ed",
    backgroundColor: "#ffffff",
    boxShadow: state.isFocused ? "0 0 0 3px #dbeafe" : "none",
    cursor: "pointer",
    fontSize: 13,
    "&:hover": { borderColor: "#94a3b8" },
  }),
  singleValue: (base) => ({ ...base, color: "#163653", fontWeight: 600 }),
  valueContainer: (base) => ({ ...base, padding: "2px 12px" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base, state) => ({
    ...base,
    padding: 8,
    color: "#64748b",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 1060 }),
  menu: (base) => ({
    ...base,
    marginTop: 6,
    marginBottom: 6,
    borderRadius: 10,
    border: "1px solid #dbe3ed",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 28px rgba(15, 23, 42, 0.14)",
    overflow: "hidden",
  }),
  menuList: (base) => ({ ...base, padding: 4 }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    minHeight: 44,
    padding: "10px 12px",
    borderRadius: 6,
    fontSize: 13,
    fontWeight: state.isSelected ? 600 : 400,
    backgroundColor: state.isSelected ? "#163653" : state.isFocused ? "#eff6ff" : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#334155",
    cursor: "pointer",
    ":active": { backgroundColor: state.isSelected ? "#163653" : "#dbeafe" },
  }),
};

export default function PageSizeSelect({ value, options, onChange, isDisabled = false }) {
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);

  React.useEffect(() => {
    if (!menuIsOpen) return;
    const closeMenu = () => setMenuIsOpen(false);
    const viewport = window.visualViewport;
    window.addEventListener("resize", closeMenu);
    viewport?.addEventListener("resize", closeMenu);
    viewport?.addEventListener("scroll", closeMenu);
    return () => {
      window.removeEventListener("resize", closeMenu);
      viewport?.removeEventListener("resize", closeMenu);
      viewport?.removeEventListener("scroll", closeMenu);
    };
  }, [menuIsOpen]);

  return (
    <Select
      classNamePrefix="page-size-select"
      name="Baris per halaman"
      aria-label="Baris per halaman"
      value={options.find((option) => option.value === value)}
      options={options}
      onChange={onChange}
      isDisabled={isDisabled}
      isSearchable={false}
      menuIsOpen={menuIsOpen}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={() => setMenuIsOpen(false)}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
      menuPlacement="auto"
      menuShouldScrollIntoView={false}
      maxMenuHeight={180}
      // Close when the page or a table scrolls; allow scrolling inside the menu.
      closeMenuOnScroll={(event) => !event.target?.closest?.(".page-size-select__menu")}
      styles={styles}
    />
  );
}
